var module = angular.module('octopusApp.shared');

module.directive('userName', function (busy, octopusRepository) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      userId: '=',
      nullText: '='
    },
    templateUrl: 'areas/shared/views/user-name.html',
    link: function (scope) {
      var isLoading = scope.isLoading = busy.create();
      var usersById = {};

      scope.$watch('userId', function() {
        if (!scope.userId) {
          scope.username = "";
          scope.displayName = "";
        } else {
          if (!usersById[scope.userId]) {
            isLoading.promise(octopusRepository.Users.get(scope.userId).then(function (user) {
              usersById[scope.userId] = user;
              scope.username = user.Username;
              scope.displayName = user.DisplayName;
            }));
          } else {
            scope.username = usersById[scope.userId].Username;
            scope.displayName = usersById[scope.userId].DisplayName;
          }
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/user_name.js
// module id = 603
// module chunks = 1